import ReportBand from './ReportBand'

/**
 * "Saved result — as of {time}" banner, shown when a report is reopened from the
 * My Reports tray (?jobId). Makes clear the data is a durable snapshot, not a live
 * run. Shared by the generic engine (ReportView) and specialized reports
 * (SpecializedReportShell). Renders nothing when there's no saved timestamp.
 *
 * spec 092: this is now a thin wrapper over ReportBand's `stale` variant rather
 * than its own amber div. It was the first of five bespoke coloured bands and it
 * keeps its own name because "is this a snapshot?" is a distinct question with a
 * distinct answer — but the colours, spacing, glyph and announcement now come
 * from one place, so the next band cannot drift from it.
 *
 * The API is unchanged on purpose: both call sites still pass only `asOf`.
 *
 * @param {{ asOf?: number }} props ms timestamp of when the saved job was created.
 */
export default function SavedResultBanner({ asOf }) {
  if (!asOf) return null
  return (
    <ReportBand variant="stale" className="mb-4" data-testid="saved-result-banner">
      Saved result — <strong className="font-semibold">as of {new Date(asOf).toLocaleString()}</strong>.
      {' '}Change a filter or run the report again to refresh.
    </ReportBand>
  )
}
